import * as React from 'react';

// Utils
import cx from 'classnames';

// Styling
import styles from './style.scss';

export type SignupAlreadyRegisteredLoginButtonProps = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
};

export default function SignupAlreadyRegisteredLoginButton({
  text,
  onClick,
  disabled = false,
  className,
}: SignupAlreadyRegisteredLoginButtonProps) {
  return (
    <button
      type="button"
      className={cx(styles.button, className)}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
}
